
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Users } from 'lucide-react';
import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Tooltip } from 'recharts';

interface AudienceMetricsChartProps {
  audienceMetrics: any[];
}

const AudienceMetricsChart: React.FC<AudienceMetricsChartProps> = ({ audienceMetrics }) => {
  return (
    <Card className="bg-card/95 border-border/50">
      <CardHeader>
        <CardTitle className="text-xl flex items-center gap-2 text-white/95">
          <Users className="h-5 w-5 text-soundcharts-purple" />
          Audience Metrics
        </CardTitle>
        <CardDescription className="text-white/70">
          Engagement and retention statistics
        </CardDescription>
      </CardHeader>
      <CardContent className="flex items-center justify-center">
        <div className="h-[250px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <RadarChart cx="50%" cy="50%" outerRadius={80} data={audienceMetrics}>
              <PolarGrid stroke="rgba(255,255,255,0.1)" />
              <PolarAngleAxis 
                dataKey="subject" 
                tick={{ fill: 'rgba(255,255,255,0.7)', fontSize: 10 }} 
              />
              <PolarRadiusAxis 
                angle={30} 
                domain={[0, 100]} 
                tick={{ fill: 'rgba(255,255,255,0.7)' }} 
              />
              <Radar 
                name="Audience" 
                dataKey="A" 
                stroke="#9b87f5" 
                fill="#9b87f5" 
                fillOpacity={0.6} 
              />
              <Tooltip 
                contentStyle={{ 
                  backgroundColor: 'rgba(0,0,0,0.8)', 
                  borderColor: 'rgba(255,255,255,0.1)',
                  borderRadius: '8px',
                  color: 'rgba(255,255,255,0.9)'
                }} 
              />
            </RadarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default AudienceMetricsChart;
